/**
 * @generated SignedSource<<55eb0a96f68ed8b791194d9ad5af7c76>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteClinicianAvailabilityByIdInput = {
  clientMutationId?: string | null;
  id: string;
};
export type ClinicianAvailabilitiesTableDeleteClinicianAvailabilityMutation$variables = {
  connections: ReadonlyArray<string>;
  input: DeleteClinicianAvailabilityByIdInput;
};
export type ClinicianAvailabilitiesTableDeleteClinicianAvailabilityMutation$data = {
  readonly deleteClinicianAvailabilityById: {
    readonly deletedClinicianAvailabilityId: string | null;
  } | null;
};
export type ClinicianAvailabilitiesTableDeleteClinicianAvailabilityMutation = {
  response: ClinicianAvailabilitiesTableDeleteClinicianAvailabilityMutation$data;
  variables: ClinicianAvailabilitiesTableDeleteClinicianAvailabilityMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedClinicianAvailabilityId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClinicianAvailabilitiesTableDeleteClinicianAvailabilityMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteClinicianAvailabilityPayload",
        "kind": "LinkedField",
        "name": "deleteClinicianAvailabilityById",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClinicianAvailabilitiesTableDeleteClinicianAvailabilityMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteClinicianAvailabilityPayload",
        "kind": "LinkedField",
        "name": "deleteClinicianAvailabilityById",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "deletedClinicianAvailabilityId",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "25d3c0dba2cf4c4a198a61bf98961888",
    "id": null,
    "metadata": {},
    "name": "ClinicianAvailabilitiesTableDeleteClinicianAvailabilityMutation",
    "operationKind": "mutation",
    "text": "mutation ClinicianAvailabilitiesTableDeleteClinicianAvailabilityMutation(\n  $input: DeleteClinicianAvailabilityByIdInput!\n) {\n  deleteClinicianAvailabilityById(input: $input) {\n    deletedClinicianAvailabilityId\n  }\n}\n"
  }
};
})();

(node as any).hash = "9f7949b78709af5e0bba7d2ec4023e57";

export default node;
